{
    "FormEngineButtonElement": {
        "title": "Button"
    },
    "mask": {
        "FormEngineButtonElement": {
            "isBlock": "Block",
            "variant": "Variant",
            "requireValid": "Disable on page error",
            "requireOnline": "Disable when offline",
            "action": "Action",
            "eventName": "Signal",
            "pageName": "Target Page",
            "url": "Url",
            "urlTarget": "Target"
        }
    }
}